import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import styles from './TagsInput.module.sass';
import Card from 'components/Card';
import TextInput from 'components/TextInput';
import Icon from 'components/Icon';
import useAuth from 'hooks/useAuth';
import devscntrAuth from 'api/Instance/devscntrAuth';
import devscntrNoauth from 'api/Instance/devscntrNoauth';
import axios from 'axios';
import { showError } from 'utils/showError';
import { validateInput } from 'utils/validation';
import OutsideClickHandler from 'react-outside-click-handler';
import { tagColors } from 'data/tagColors';
import { tagsEndpoints } from 'api/endpoints';
import { colorRelatedToBackground } from 'utils';

const TagsInput = ({ className, tags, setTags, maxTagNumber = 8 }) => {
  const authCtx = useAuth();
  const axiosInstance = authCtx.isLoggedIn ? devscntrAuth : devscntrNoauth;

  const [tagInput, setTagInput] = useState('');
  const [categories, setCategories] = useState([]);
  const [hint, setHint] = useState('');
  const [visibleHint, setVisibleHint] = useState(false);

  const compareNumbers = (a, b) => {
    return b.tags_count - a.tags_count;
  };

  const getCategories = async cancelToken => {
    try {
      const response = await axiosInstance.request({
        method: 'get',
        url: `${tagsEndpoints.show}?limit=10000`,
        cancelToken: cancelToken.token,
      });
      console.log(response.data);
      const cats = response?.data?.sort(compareNumbers);
      setCategories(cats);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const cancelToken = axios.CancelToken.source();
    getCategories(cancelToken);

    return () => {
      cancelToken.cancel();
    };
  }, []);

  const getHint = value => {
    if (value === '') return '';

    setVisibleHint(true);
    const allHints = categories.filter(item =>
      item?.name?.trim().toLowerCase().includes(value?.trim().toLowerCase())
    );
    console.log(allHints);
    return allHints?.length > 0 ? allHints[0] : '';
  };

  const useHint = () => {
    handleAddTag(hint.name, hint.colour);
    setHint('');
  };

  const handleChange = e => {
    setTagInput(e.target.value);
    setHint(getHint(e.target.value));
  };

  useEffect(() => {
    console.log(hint);
  }, [hint]);

  const handleKeyDown = e => {
    if (e.key !== 'Enter') return;
    handleAddTag(
      tagInput,
      tagColors[Math.floor(Math.random() * tagColors.length)]
    );
  };

  const handleAddTag = (
    value,
    colour = tagColors[Math.floor(Math.random() * tagColors.length)]
  ) => {
    if (!value?.length > 0) return;
    if (!validateInput(value.trim().toLowerCase(), 40, 2, 'tag', 'text')) {
      return;
    }

    let alreadyExists = false;
    tags.forEach(item => {
      if (item === value.trim().toLowerCase()) {
        showError('Podany tag jest już na liście');
        alreadyExists = true;
        return;
      }
    });

    if (value !== '' && tags.length < maxTagNumber && !alreadyExists) {
      setTags([
        ...tags,
        {
          name: value.trim().toLowerCase(),
          colour: colour,
        },
      ]);
      setTagInput('');
      console.log(tags);
    }
  };

  const removeTag = index => {
    setTags(tags.filter((tag, i) => i !== index));
  };

  return (
    <Card
      className={cn(styles.card, className)}
      title='Tagi'
      classTitle='title-purple'
      head={`${tags.length}/${maxTagNumber}`}
    >
      <div className={styles.input_container}>
        <input
          placeholder='Podaj tag i zatwierdź enterem'
          className={styles.input}
          onKeyDown={handleKeyDown}
          value={tagInput}
          onChange={handleChange}
          onFocus={() => setVisibleHint(true)}
        />

        <button className={cn('button')} onClick={() => handleAddTag(tagInput)}>
          Dodaj
        </button>
      </div>

      {hint.name?.length > 0 && visibleHint && (
        <OutsideClickHandler onOutsideClick={() => setVisibleHint(false)}>
          <button
            className={cn(
              styles.hint,
              colorRelatedToBackground(
                hint.colour !== 'undefined' ? hint.colour : '#ffffff'
              ) === 'light'
                ? styles.text_light
                : styles.text_dark
            )}
            style={{ backgroundColor: hint.colour || '#ffffff' }}
            onClick={useHint}
          >
            {hint.name}
          </button>
        </OutsideClickHandler>
      )}

      <div className={styles.container}>
        {tags.map((tag, index) => (
          <div
            className={cn(
              styles.tag,
              colorRelatedToBackground(
                tag.colour !== 'undefined' ? tag.colour : '#ffffff'
              ) === 'light'
                ? styles.text_light
                : styles.text_dark
            )}
            style={{ backgroundColor: tag.colour || '#ffffff' }}
            key={index}
          >
            <span className={styles.text}>{tag.name}</span>
            <div className={styles.remove} onClick={() => removeTag(index)}>
              <Icon name='close' size={18} />
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};
export default TagsInput;
